import React from "react";
import Sidebar from "../../../components/Sidebar";
import ComingSoon from "../../../components/comingSoon/ComingSoon";

const MySimulations = () => {
  return (
    <Sidebar>
      <ComingSoon content="We're building an amazing simulation tracking system for you. Soon you'll be able to review your practice sessions, track progress, and analyze your performance." />
    </Sidebar>
  );
};

export default MySimulations; 